document.addEventListener("DOMContentLoaded", () => {
  const flavourInputs = document.querySelectorAll('input[name="flavour-options"]');
  
  flavourInputs.forEach(input => {
    input.addEventListener("change", function() {
      const handle = this.value; // The value attribute holds the product handle.
      if(handle) {
        window.location.href = "/products/" + handle;
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  const sizeRadios = document.querySelectorAll('input[name="size-options"]');
  const priceElement = document.querySelector('.product-price'); // Make sure this targets the correct price element
  
  sizeRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      const selectedVariantId = radio.value;
      const selectedVariant = Shopify.product.variants.find(variant => variant.id == selectedVariantId);
      
      if (selectedVariant) {
        // Update the price on the page
        priceElement.textContent = selectedVariant.price | money; // Ensure the price is formatted
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.nutrition-toggle');
  const content = document.querySelector('.nutrition-content');

  if (toggle && content) {
    toggle.addEventListener('click', function () {
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !isExpanded);
      content.hidden = isExpanded;
    });
  }
});
